import Montaverde1 from '../../../Media/Cibubur/Monteverde.webp'
import Montaverde2 from '../../../Media/Cibubur/MV.webp'

const Montaverdeimages =[
Montaverde1,Montaverde2,
]

export default Montaverdeimages;